import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.development';
import { constantvalues } from '../../../const';
import { Observable } from 'rxjs';
import { 
  DtoNotificationCount,
  DtoDataAlertCategory, DtoDataAlertSubscription, DtoDataAlertType, 
  DtoNotifications, DtoNotificationType 
} from '../../../models/notifications.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  baseURL: string;
  constructor(private httpClient: HttpClient) {
    this.baseURL = environment.gatewayUrl;
  }

  fetchDataAlertCategories(sectorId: number): Observable<DtoDataAlertCategory[]> {
    return this.httpClient.get<DtoDataAlertCategory[]>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/data-alert-categories?sectorid=${sectorId}`);
  }

  fetchDataAlertTypes(sectorId: number, categoryId: number): Observable<DtoDataAlertType[]> {

    return categoryId == 0 ?
      this.httpClient.get<DtoDataAlertType[]>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/subscribed-data-alert-types?sectorId=${sectorId}`)
      :
      this.httpClient.get<DtoDataAlertType[]>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/data-alert-types?categoryId=${categoryId}`);
  }

  pauseAllDataAlertSubscriptions(sectorId: number):Observable<DtoDataAlertSubscription[]>{
    return this.httpClient.get<DtoDataAlertSubscription[]>(
      `${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/data-alert-subscriptions-pause-all`
    );
  }

  resumeAllDataAlertSubscriptions(sectorId: number):Observable<DtoDataAlertSubscription[]>{
    return this.httpClient.get<DtoDataAlertSubscription[]>(
      `${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/data-alert-subscriptions-resume-all`
    );
  }

  saveDataAlertsubscription(dataAlertSubscription: DtoDataAlertSubscription): Observable<DtoDataAlertSubscription> {

    return this.httpClient.post<DtoDataAlertSubscription>(
      `${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/data-alert-subscriptions`,
      dataAlertSubscription
    );
  }


  fetchDataAlertSubscriptions(sectorId: number): Observable<DtoDataAlertSubscription[]> {
    return this.httpClient.get<DtoDataAlertSubscription[]>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/data-alert-subscriptions?sectorid=${sectorId}`);
  }

  fetchNotificationTypes(): Observable<DtoNotificationType[]> {
    return this.httpClient.get<DtoNotificationType[]>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/notification-types`);
  }

  fetchNotificationCount(email: string, status: number): Observable<DtoNotificationCount> {
    return this.httpClient.get<DtoNotificationCount>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/${email}/${status}/count`);
  }

  archive_notification_message(notificationId: number) {
    return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/${notificationId}`);
  }

  fetchNotifications(email: string, status: number): Observable<DtoNotifications[]> {
    return this.httpClient.get<DtoNotifications[]>(`${this.baseURL}${constantvalues.API_URL.GET_NOTIFICATIONS}/${email}/${status}`);
  }

  getPackageDetails(packageChangeRequestId: number) {
    return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.PACKAGE_ROOT_URL}/${packageChangeRequestId}`);
  }
}
